import { t } from "i18next";

import { EReputationMatchResult, GroupedRole, PersonProfile, Role } from "src/core/types/entity";
import { formatDateToFr } from "src/core/utils/date";
import { toSnakeCase } from "src/core/utils/text";

type RolesSectionProps = {
  selectedMatch: EReputationMatchResult;
};

function isPersonProfileWithRoles(
  detail: EReputationMatchResult["detail"]
): detail is PersonProfile {
  return detail != null && "roles" in detail && Array.isArray(detail.roles);
}

export const RolesSection = ({ selectedMatch }: RolesSectionProps) => {
  const detail = selectedMatch?.detail;
  if (!isPersonProfileWithRoles(detail) || !detail.roles.length) {
    return null;
  }

  return (
    <div className="px-10 space-y-8">
      {detail.roles.map(({ type, roles }: GroupedRole, groupRoleIndex: number) => (
        <div key={groupRoleIndex}>
          {/* En-tête du groupe */}
          <div className="text-center mb-4">
            <div className="font-light border border-border rounded-lg px-6 py-3 bg-gray-xxlight">
              {t(`modal.entityDetails.sections.roles.${toSnakeCase(type)}`)}
            </div>
          </div>

          {/* Lignes des rôles */}
          <div className="space-y-4">
            {/* Header de colonne */}
            <div className="grid grid-cols-12 uppercase">
              <div className="col-span-8"></div>
              <div className="col-span-2 text-right">
                {t("modal.entityDetails.sections.roles.start_date")}
              </div>
              <div className="col-span-2 text-right">
                {t("modal.entityDetails.sections.roles.end_date")}
              </div>
            </div>

            {roles.map((role: Role, index: number) => (
              <div key={`role-${groupRoleIndex}-${index}`} className="grid grid-cols-12">
                {/* Fonction + catégorie */}
                <div className="col-span-8">
                  <div className="">{role.occupation}</div>
                  <div className="font-light ml-20">{role.occupationCategory}</div>
                </div>

                {/* Dates */}
                <div className="col-span-2 text-right font-light">
                  {formatDateToFr(role.startDate)}
                </div>
                <div className="col-span-2 text-right font-light">
                  {formatDateToFr(role.endDate)}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
